// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CheckCircleFilledSvg from "@ant-design/icons-svg/es/asn/CheckCircleFilled";
import AntdIcon from '../components/AntdIcon';

var CheckCircleFilled = function CheckCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CheckCircleFilledSvg
  }));
};

CheckCircleFilled.displayName = 'CheckCircleFilled';
export default /*#__PURE__*/React.forwardRef(CheckCircleFilled);